/* eslint-disable react/button-has-type */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RawHtml from 'common/RawHtml';
import Button from 'common/Button';
import Spinner from 'common/Spinner';
import backButtonStyles from 'pages/styles/backButton';
import { withStyles } from 'theme/withStyles';
import pageActions from 'core/page/actions';

const styles = (theme) => ({
  back: backButtonStyles(theme),
  button: {
    margin: [0, 0, theme.spacing.xs, 0],
  },
  forceShow: {},
  root: {
    '&$forceShow': {
      display: 'block',
      [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
        display: 'block',
      },
    },
    display: 'block',
    margin: '0 auto',
    maxWidth: theme.forms.maxWidth,
    padding: [0, theme.spacing.xs * 2],

    [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
      display: 'none',
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column-reverse',
    margin: [theme.spacing.xl, 0, 0, 0],
  },
});

const ButtonRowPage = ({
  backAllowed,
  backButtonLabel,
  classes,
  continueAllowed,
  disableButton,
  loading,
  name,
  onBack,
  onNext,
  onSave,
  saveAndContinueAllowed,
  saveButtonLabel,
  submitButtonLabel,
}) => (
  <div
    className={classnames('row btn-row-page', `btn-page-${name}`, classes.root, {
      [classes.forceShow]: name === 'esign' || name === 'productoptions',
    })}
  >
    <div className={classnames('col-lg-12', classes.wrapper)}>
      {backAllowed && (
        <RawHtml
          className={classnames(
            'btn btn-mobile btn-tertiary btn-page-back',
            classes.button,
            classes.back,
          )}
          data-name="btn-page-back"
          type="button"
          onClick={onBack}
          variant="secondary"
          disabled={loading}
        >
          {backButtonLabel}
        </RawHtml>
      )}
      {saveAndContinueAllowed && (
        <RawHtml
          className={classnames(
            'btn btn-mobile btn-tertiary btn-save-and-continue',
            classes.button,
          )}
          data-name="btn-save-and-continue"
          type="button"
          disabled={disableButton}
          onClick={onSave}
          variant="secondary"
        >
          {saveButtonLabel}
        </RawHtml>
      )}
      {continueAllowed && (
        <Button
          className={classnames(`btn btn-mobile btn-page-next btn-next-${name}`, classes.button, {
            loading,
          })}
          data-name="btn-page-next"
          onClick={onNext}
          disabled={disableButton}
        >
          <RawHtml type="span">{submitButtonLabel}</RawHtml>
          <i className="icon-arrow-thin-right" aria-hidden="true" />
          <Spinner loading={loading} />
        </Button>
      )}
    </div>
  </div>
);

ButtonRowPage.propTypes = {
  backAllowed: PropTypes.bool,
  backButtonLabel: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  continueAllowed: PropTypes.bool.isRequired,
  disableButton: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onSave: PropTypes.func,
  saveAndContinueAllowed: PropTypes.bool,
  saveButtonLabel: PropTypes.string,
  submitButtonLabel: PropTypes.string,
};

ButtonRowPage.defaultProps = {
  backAllowed: false,
  backButtonLabel: '',
  disableButton: false,
  loading: false,
  name: '',
  onBack: () => {},
  onNext: () => {},
  onSave: () => {},
  saveAndContinueAllowed: false,
  saveButtonLabel: '',
  submitButtonLabel: '',
};

const ButtonRowPageStyled = withStyles(styles)(ButtonRowPage);

const mapDispatchToProps = {
  onBack: pageActions.back,
  onNext: pageActions.next,
  onSave: pageActions.save,
};

export default connect(null, mapDispatchToProps)(ButtonRowPageStyled);
